import { GamepadActionId } from 'generated/graphql';

export const DICTAPHONE_BUTTON_ACTION_LABELS = {
  [GamepadActionId.Record]: 'Record',
  [GamepadActionId.Forward]: 'Forward',
  [GamepadActionId.Back]: 'Back',
  [GamepadActionId.ExitField]: 'Exit Field',
  [GamepadActionId.DeleteForward]: 'Delete Forward',
  [GamepadActionId.DeleteBackward]: 'Delete Backward',
  [GamepadActionId.DeleteWordBackward]: 'Delete Word Backward',
  [GamepadActionId.NewLine]: 'New Line',
  [GamepadActionId.EndOfLine]: 'End of Line',
  [GamepadActionId.EndOfReport]: 'End of Report',
  [GamepadActionId.Space]: 'Space',
  [GamepadActionId.Undo]: 'Undo',
  [GamepadActionId.DraftReport]: 'Save as Draft',
  [GamepadActionId.SubmitPrelimReport]: 'Sign as Preliminary',
  [GamepadActionId.GenerateImpression]: 'Generate Impression',
  [GamepadActionId.SubmitReport]: 'Submit Report',
  [GamepadActionId.ToggleFocusMode]: 'Toggle Focus Mode',
  [GamepadActionId.ToggleVisibility]: 'Toggle Visibility',
  [GamepadActionId.CommandMode]: 'Command Mode',
} as const satisfies Record<GamepadActionId, string>;

export type DictaphoneButtonActionScope = 'reporter' | 'viewer';
export type DictaphoneButtonActionCategory =
  | 'coreControls'
  | 'textEditing'
  | 'reportNavigation'
  | 'reportWorkflow';

export const DICTAPHONE_BUTTON_ACTION_SCOPE_LABELS = {
  reporter: 'Reporter',
  viewer: 'Viewer',
} as const satisfies Record<DictaphoneButtonActionScope, string>;

export const DICTAPHONE_BUTTON_ACTION_SCOPES = {
  [GamepadActionId.Record]: 'reporter',
  [GamepadActionId.Forward]: 'reporter',
  [GamepadActionId.Back]: 'reporter',
  [GamepadActionId.ExitField]: 'reporter',
  [GamepadActionId.DeleteForward]: 'reporter',
  [GamepadActionId.DeleteBackward]: 'reporter',
  [GamepadActionId.DeleteWordBackward]: 'reporter',
  [GamepadActionId.NewLine]: 'reporter',
  [GamepadActionId.EndOfLine]: 'reporter',
  [GamepadActionId.EndOfReport]: 'reporter',
  [GamepadActionId.Space]: 'reporter',
  [GamepadActionId.Undo]: 'reporter',
  [GamepadActionId.DraftReport]: 'reporter',
  [GamepadActionId.SubmitPrelimReport]: 'reporter',
  [GamepadActionId.GenerateImpression]: 'reporter',
  [GamepadActionId.SubmitReport]: 'reporter',
  [GamepadActionId.ToggleFocusMode]: 'reporter',
  [GamepadActionId.ToggleVisibility]: 'reporter',
  [GamepadActionId.CommandMode]: 'reporter',
} as const satisfies Record<GamepadActionId, DictaphoneButtonActionScope>;

export const DICTAPHONE_BUTTON_ACTION_CATEGORY_LABELS = {
  coreControls: 'Core Controls',
  textEditing: 'Text Editing',
  reportNavigation: 'Report Navigation',
  reportWorkflow: 'Report Workflow',
} as const satisfies Record<DictaphoneButtonActionCategory, string>;

export const DICTAPHONE_BUTTON_ACTION_CATEGORIES = {
  [GamepadActionId.Record]: 'coreControls',
  [GamepadActionId.Forward]: 'reportNavigation',
  [GamepadActionId.Back]: 'reportNavigation',
  [GamepadActionId.ExitField]: 'reportNavigation',
  [GamepadActionId.DeleteForward]: 'textEditing',
  [GamepadActionId.DeleteBackward]: 'textEditing',
  [GamepadActionId.DeleteWordBackward]: 'textEditing',
  [GamepadActionId.NewLine]: 'textEditing',
  [GamepadActionId.EndOfLine]: 'reportNavigation',
  [GamepadActionId.EndOfReport]: 'reportNavigation',
  [GamepadActionId.Space]: 'textEditing',
  [GamepadActionId.Undo]: 'textEditing',
  [GamepadActionId.DraftReport]: 'reportWorkflow',
  [GamepadActionId.SubmitPrelimReport]: 'reportWorkflow',
  [GamepadActionId.GenerateImpression]: 'reportWorkflow',
  [GamepadActionId.SubmitReport]: 'reportWorkflow',
  [GamepadActionId.ToggleFocusMode]: 'coreControls',
  [GamepadActionId.ToggleVisibility]: 'coreControls',
  [GamepadActionId.CommandMode]: 'coreControls',
} as const satisfies Record<GamepadActionId, DictaphoneButtonActionCategory>;

export const getActionLabel = (action: GamepadActionId): string =>
  DICTAPHONE_BUTTON_ACTION_LABELS[action];

export const getActionScope = (action: GamepadActionId): DictaphoneButtonActionScope =>
  DICTAPHONE_BUTTON_ACTION_SCOPES[action];

export const getActionScopeLabel = (scope: DictaphoneButtonActionScope): string =>
  DICTAPHONE_BUTTON_ACTION_SCOPE_LABELS[scope];

export const getActionCategory = (action: GamepadActionId): DictaphoneButtonActionCategory =>
  DICTAPHONE_BUTTON_ACTION_CATEGORIES[action];

export const getActionCategoryLabel = (category: DictaphoneButtonActionCategory): string =>
  DICTAPHONE_BUTTON_ACTION_CATEGORY_LABELS[category];
